import { Command } from '@/app/common/base/command'

export class SubmitInventoryFormCommand extends Command {
    public async run(data: object, productActionId: string) {
        await this.client.post('/api/inventory-form', { data, productActionId })
    }
}
